import { render, staticRenderFns } from "./ThreadDeletedComments.vue?vue&type=template&id=573b986c&"
import script from "./ThreadDeletedComments.vue?vue&type=script&lang=js&"
export * from "./ThreadDeletedComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports